
  import { defineComponent } from 'vue';
  
  export default defineComponent({
    name: 'DefaultComponent',
    props: {
      title: String
    },
  });
